import { render } from "./nativeAppHeader.vue?vue&type=template&id=b9fbeab8&scoped=true&ts=true"
import script from "./nativeAppHeader.vue?vue&type=script&lang=ts"
export * from "./nativeAppHeader.vue?vue&type=script&lang=ts"

import "./nativeAppHeader.vue?vue&type=style&index=0&id=b9fbeab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fbeab8"]])

export default __exports__